// Keep the historical PostHog names; Touchpoint uses subject_action names.
export const TOUCHPOINT_EVENTS = {
  generation_begin: 'paywallExperimentGeneration_begin',
  generation_complete: 'paywallExperimentGeneration_complete',
  email_prompt_shown: 'paywallExperimentEmailPrompt_view',
  email_entered: 'paywallExperimentEmail_enter',
  visit_superwall_clicked: 'paywallExperimentSuperwallLink_tap',
  share_link_clicked: 'paywallExperimentShareLink_tap',
  try_another_clicked: 'paywallExperimentTryAnotherButton_tap',
  example_clicked: 'paywallExperimentExample_tap',
} as const;

export function browserEvent(input: unknown) {
  if (!input || typeof input !== 'object') return null;
  const { event, properties } = input as Record<string, unknown>;
  if (typeof event !== 'string' || !Object.hasOwn(TOUCHPOINT_EVENTS, event)) return null;
  const props: Record<string, string | number | boolean> = {};
  if (properties && typeof properties === 'object') {
    const p = properties as Record<string, unknown>;
    for (const key of ['slug', 'example_id']) {
      if (typeof p[key] === 'string' && /^[a-zA-Z0-9_-]{1,128}$/.test(p[key])) props[key] = p[key];
    }
    if (typeof p.has_email === 'boolean') props.has_email = p.has_email;
    if (Number.isInteger(p.image_count) && (p.image_count as number) >= 0 && (p.image_count as number) <= 100) {
      props.image_count = p.image_count as number;
    }
  }
  return { name: TOUCHPOINT_EVENTS[event as keyof typeof TOUCHPOINT_EVENTS], properties: props };
}
